import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Table} from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { 
	getEmployeeScheduleList, doEmployeeScheduleDelete, 
	doEmployeeScheduleReset 
} from "../../../../../redux/employee/employeeState";
import { handleTableChange } from "../../../../../utils/index";
import PopupButton from "components/button/PopupButton";
import ScheduleForm from "./ScheduleForm";




const ScheduleTable = ({recordList, pagination, doSearch, filters, doDelete, employeeId, doRecordReset }) => {

  	const columns = [
	    {
	        title: `Effective Date`,
	        dataIndex: 'esd_effective_date_from',
	        key: 'esd_effective_date_from',
	        width: '88%',
	        render: (esd_effective_date_from, record) => <span>{`${esd_effective_date_from ?? ''}`} to {`${record?.esd_effective_date_to ?? 'Present'}`}</span> 
	    },
	    {
	        title: (
				<div className="flex justify-center">
					<PopupButton id="add_employee_schedule" title="Add Schedule" label="Add" btnClass="btn-small">
						<ScheduleForm recordId={0} mode="edit" employeeId={employeeId} />
					</PopupButton>
				</div>
			),
	        dataIndex: 'esd_id',
	        key: 'esd_id',
	        width: '12%',
	        render:(_, record) => <CrudOption 
										baseRoute={`/console/employees/${employeeId}/employee-schedules`} 
										recordId={record?.esd_id} 
										allowEdit={false} 
										deleteHandler={() => doDelete({
											esd_employee_id: record?.esd_employee_id,
											esd_id: record?.esd_id,
										})} 
										viewMode="modal"
										title="Edit Schedule"
										closeHandler={doRecordReset}
										viewHandler={(recordId, doRecordReset) => (
											<ScheduleForm 
												recordId={recordId} 
												employeeId={employeeId} 
												mode="edit" 
												onCancel={doRecordReset} 
											/>
										)}
									/>
	    },
    ];

	useEffect(() => {
		if (employeeId) {
			doSearch({paginate: pagination.per_page, employeeId});
		} 
	}, [doSearch, employeeId, pagination.per_page]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-auto xl:overflow-x-hidden">
	      		<Table 
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.esd_id}
					scroll={{ x: "max-content" }}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
		            onChange={handleTableChange(doSearch, filters)}             	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.employee.employeeScheduleList?.items,
	pagination: state.employee.employeeScheduleList?.pagination,
	filters: state.employee.employeeScheduleList?.filters,
  	requesting: state.employee.employeeScheduleList?.requesting,
  	error: state.employee.employeeScheduleList?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getEmployeeScheduleList(filters)),
  doDelete: (id) => dispatch(doEmployeeScheduleDelete(id)),
  doRecordReset: () => dispatch(doEmployeeScheduleReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleTable);